import styled from 'styled-components'
import { Upload } from 'antd'

const AntUploadStyled = styled(Upload)``

export default AntUploadStyled
